import { createFileRoute, redirect } from "@tanstack/react-router"
import { useAuthStore } from "@/store/auth.store"

export const Route = createFileRoute("/dashboard/quotations")({
  beforeLoad: () => {
    const { isAuthenticated, user, buyerId } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({ to: "/login" })
    }

    const role = user?.role?.toUpperCase()
    if (role === "BUYER" && !buyerId && !user?.buyer?.id) {
      throw redirect({ to: "/buyer-profile-setup" })
    }
  },
})
